<div
	[ngClass]="isLoading ? 'list-widget-quicksettings--loading':
		isBlocked ? 'list-widget-quicksettings--content-disabled' : ''">
	<div
		[ngClass]=" value ?
			'list-widget-quicksettings--content list-widget-quicksettings--content-on':
			'list-widget-quicksettings--content list-widget-quicksettings--content-off'"
	>
		<div class="quicksettings-left-info">
			<i id="{{switchId}}-Icon" attr.aria-label="{{title | translate}}" role="img" [ngClass]="['icomoon', 'quicksettings-icon', iconDefinition]"></i>
			<h4 id="{{switchId}}-Title" class="quicksettings-title">{{title | translate}}</h4>
		</div>
		<div class="quicksettings-right-info">
			<div *ngIf="!isLoading; else loading" class="quicksettings-switch">
				<material-slide-toggle #toggle
				[id]="switchId"
				[value]="value"
				[ariaLabel]="title | translate"
				[loading]="isLoading"
				[disabled]="disable"
				(toggle)="onChange($event)">
				</material-slide-toggle>
			</div>
			<ng-template #loading>
				<div class="quicksettings-loader">
					<div class="spinner-content">
						<div class="spinner-border text-secondary progress-spinner"></div>
					</div>
				</div>
			</ng-template>
		</div>
	</div>
</div>
